import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CompanyInfo from './components/CompanyInfo';
import Services from './components/Services';
import Products from './components/Products';
import WhyChooseUs from './components/WhyChooseUs';
import Stats from './components/Stats';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <CompanyInfo />
      <Services />
      <Products />
      <WhyChooseUs />
      <Stats />
      <CTA />
      <Footer />
    </div>
  );
}
